<template>
  <div>
    <v-toolbar class="my-md-auto" elevation="0"  >
      <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
        <h1><v-icon large>mdi-file-cog-outline</v-icon>{{$t('profile.profilefiles')}}</h1>
      </v-toolbar-title>
      <v-spacer />
      <div>
        <v-btn
          color=""
          class="ml-sm-2"
          @click="resetForm"
        >
          {{ $t('global.reset')}}
        </v-btn>
        <v-btn
          :loading="isLoading"
          class="ml-sm-2"
          color="primary"
          @click="onSendProdFileForm"
        >
          {{ $t('global.submit')}}
        </v-btn>
      </div>
    </v-toolbar>
    <ProfilefileForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ProfilefileForm from '../../components/profilefile/Form';
import Loading from '../../components/Loading';
import CreateMixin from '../../mixins/CreateMixin';
import FileMixin from '../../mixins/FileMixin';

const servicePrefix = 'ProfileFile';

const { mapFields } = createHelpers({
  getterType: 'profilefile/getField',
  mutationType: 'profilefile/updateField'
});

export default {
  name: 'ProfilefileCreate',
  servicePrefix,
  mixins: [CreateMixin,FileMixin],
  components: {
    Loading,
    ProfilefileForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('profilefile', ['create', 'reset']),
    onSendProdFileForm() {
      this.onSendForm();
      this.inputfile = this.item.file;
    }
  }
};
</script>
